"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ChangePasswordMobile_1 = __importDefault(require("../modals/ChangePasswordMobile"));
const ChangePassword_1 = __importDefault(require("../modals/ChangePassword"));
exports.default = ({ offline, onSubmit, toggleShowModal, showModal, isMobile, translations }) => {
    if (isMobile)
        return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: showModal && ((0, jsx_runtime_1.jsx)(ChangePasswordMobile_1.default, { onCloseModal: toggleShowModal, translations: translations, offline: offline, onSubmit: onSubmit }, void 0)) }, void 0));
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: showModal && ((0, jsx_runtime_1.jsx)(ChangePassword_1.default, { translations: translations, offline: offline, onCloseModal: toggleShowModal, onSubmit: onSubmit }, void 0)) }, void 0));
};
//# sourceMappingURL=Modal.js.map